/* Native Shopify country selection and presentation-only shipping progress.
 * Checkout remains authoritative for the actual shipping destination and rate. */
(() => {
  'use strict';
  const shippingCountry = (document.documentElement.dataset.nubsShippingCountry || 'CA').toUpperCase();
  const bind = () => {
    document.querySelectorAll('[data-nubs-cart-shipping-bar]').forEach(bar => {
      const percent = Math.max(0, Math.min(100, Number(bar.dataset.progressPercent || 0)));
      const fill = bar.querySelector('[data-nubs-cart-shipping-fill]');
      if (fill) {
        if (fill.dataset.nubsProgressClass) fill.classList.remove(fill.dataset.nubsProgressClass);
        const cls = `nubs-progress-p${Math.round(percent)}`;
        fill.dataset.nubsProgressClass = cls;
        fill.classList.add(cls);
      }
    });
  };
  document.addEventListener('change', event => {
    const field = event.target.closest?.('[data-nubs-country-select]');
    if (!field) return;
    const form = field.closest('form');
    if (form) {
      // Shopify's localization form performs a POST followed by a redirect.
      // Preserve the actual current storefront route (and filters/query string),
      // rather than sending visitors to the nonexistent /back URL.
      const path = window.location.pathname || '/';
      const target = `${path.startsWith('/') && !path.startsWith('//') ? path : '/'}${window.location.search || ''}`;
      let returnInput = form.querySelector('input[name="return_to"]');
      if (!returnInput) {
        returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        form.append(returnInput);
      }
      returnInput.value = target;
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('nubs:pagechange', bind);
  window.NubsShippingCountry = shippingCountry;
})();
